var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.img,"alt":""}})]),_c('h2',{staticClass:"title",class:( _obj = {}, _obj[_vm.color] = true, _obj )},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }